import { FC, useEffect, useRef, useState } from "react";
import membersService from "@services/members.service";
import { centricClientCheck, formatDisplayDate, getDateWithLocalTimeZone } from "@utils/helpers";
import { isEmpty } from "lodash";
import { useMemberDetailsStore } from "@stores/memberDetailsStore";

interface RefreshDataProps {
  refreshInterval?: number;
}

const RefreshData: FC<RefreshDataProps> = ({ refreshInterval = 40 * 60 * 1000 }) => {
  const [refreshData, setRefreshData] = useMemberDetailsStore((state) => [state.refreshClaimData, state.setRefreshClaimData]);
  const refreshDataRef = useRef<any>(null);
  const isCentric = centricClientCheck()

  useEffect(() => {
    console.log("RefreshData.useEffect1");
    if(isEmpty(refreshData)){
      refreshDataRef.current = setInterval(() => getRefreshData(), refreshInterval);
      getRefreshData();
    }

    return () => {
      if (refreshDataRef.current) {
        clearInterval(refreshDataRef.current);
      }
    };
  }, [refreshInterval]);

  const getRefreshData = () => {
    console.log("RefreshData.getRefreshData");

    membersService.getRefreshData().subscribe({
      next: (v) => {
        setRefreshData(v.data.data);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  return (
    <div className="f14 w400 mt-05">
      {refreshData?.map((data: any, index: number) => {
        const isLast = index === refreshData.length - 1;

        if (isCentric) {
          return (
            <span key={`refreshDate${index}`}>
              Last Claim Paid Date: {getDateWithLocalTimeZone(data.refreshDate)}
            </span>
          );
        }

        const updatedOn = data.refreshDate
          ? `updated on ${getDateWithLocalTimeZone(data.refreshDate)}`
          : "";

        const availPeriodText = data.availPeriod
          ? `(Data through ${formatDisplayDate(data.availPeriod, "createDateFormat", "")})`
          : "";

        return (
          <span key={`refreshDate${index}`}>
            {`${data.source} ${updatedOn} ${availPeriodText}${!isLast ? " | " : ""}`}
          </span>
        );
      })}
    </div>
  );
};

export default RefreshData;
